import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
export function toggleValue(array, value) {
  var _context;
  var index = _indexOfInstanceProperty(array).call(array, value);
  return index === -1 ? _concatInstanceProperty(array).call(array, [value]) : _concatInstanceProperty(_context = _sliceInstanceProperty(array).call(array, 0, index)).call(_context, _sliceInstanceProperty(array).call(array, index + 1));
}